import { useMutation, useQueryCache } from "react-query";
import useNetworkHeaders from "../../../../hooks/useNetworkHeaders";
import { getInspectionItemCommentQueryKey } from "./useInspectionItemComments";
import { putInspectionItemComment } from "../../api/inspections/putInspectionItemComment";

interface UpdateInspectionCommentMutationParams {
  onSuccess?: () => void;
}
export default function useUpdateInspectionCommentMutation(
  inspectionId: string | number,
  sectionId: string | number,
  itemId: string | number,
  { onSuccess = () => {} }: UpdateInspectionCommentMutationParams = {},
) {
  const headers = useNetworkHeaders();
  const queryCache = useQueryCache();

  const [updateCommentMutation, updateCommentMutationState] = useMutation(putInspectionItemComment(headers), {
    onSuccess: () => {
      const conversationQueryKey = getInspectionItemCommentQueryKey(inspectionId, sectionId, itemId);
      queryCache.invalidateQueries(conversationQueryKey);
      onSuccess();
    },
  });

  return {
    updateComment: (commentId: string | number, comment: string, attachments: string[]) => {
      updateCommentMutation({
        id: Number(inspectionId),
        sectionId: Number(sectionId),
        itemId: Number(itemId),
        commentId: Number(commentId),
        comment: comment,
        attachments: attachments,
      });
    },
    isLoading: updateCommentMutationState.isLoading,
  };
}
